import React from "react";

function ProfileSection({ title, icon, children, className = "" }) {
  const childrenArray = React.Children.toArray(children);
  const wrappedChildren =
    childrenArray.length > 0
      ? childrenArray.map((child, index) => {
          const isLast = index === childrenArray.length - 1;
          if (!React.isValidElement(child)) return child;
          const existingClass = child.props?.className ?? "";
          const newClass = isLast
            ? `${existingClass} border-bottom-0`.trim()
            : existingClass;
          return React.cloneElement(child, { className: newClass });
        })
      : children;

  return (
    <div
      className={`profile-section rounded-3 p-3 bg-light bg-opacity-50 border ${className}`.trim()}
    >
      <h6 className="text-secondary text-uppercase fw-semibold small mb-2 d-flex align-items-center gap-2">
        <i className={`${icon} text-primary`} />
        {title}
      </h6>
      <div className="profile-section-fields">{wrappedChildren}</div>
    </div>
  );
}

export default ProfileSection;
